<script lang="ts">
  import Search from '@lucide/svelte/icons/search';
  import X from '@lucide/svelte/icons/x';

  import { getServices } from '../../app/context';
  import { strings } from '../../strings';

  let { class: className }: { class?: string } = $props();

  const { view } = getServices();
  const id = $props.id();
  let input: HTMLInputElement | undefined = $state();
</script>

<div class={['relative flex items-center', className]}>
  <label for={id} class="sr-only">{strings.searchLabel}</label>
  <Search size={16} aria-hidden="true" class="pointer-events-none absolute left-3 text-ink-muted" />
  <input
    bind:this={input}
    {id}
    type="search"
    data-search
    bind:value={view.query}
    placeholder={strings.searchPlaceholder}
    autocomplete="off"
    enterkeyhint="search"
    class="h-9 w-full min-w-0 rounded-lg border border-line-strong/50 bg-surface pr-9 pl-9 text-base text-ink placeholder:text-ink-muted sm:text-sm pointer-coarse:h-11 [&::-webkit-search-cancel-button]:hidden"
    onkeydown={(event) => {
      if (event.key === 'Escape' && view.query !== '') {
        event.stopPropagation();
        view.query = '';
      }
    }}
  />
  {#if view.query !== ''}
    <button
      type="button"
      aria-label={strings.clearSearch}
      class="absolute right-1 grid size-7 place-items-center rounded-md text-ink-muted hover:text-ink pointer-coarse:size-10"
      onclick={() => {
        view.query = '';
        input?.focus();
      }}
    >
      <X size={16} aria-hidden="true" />
    </button>
  {/if}
</div>
